import de from './de.svg';
import it from './it.svg';
import fr from './fr.svg';
import sr from './sr.svg';
import en from './en.svg';

const flags = { de, it, fr, sr, en };

export default flags;
